module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "GrowthDashboardpdf",
    attrs: {
      "id": "GrowthDashboardpdf"
    }
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 col-sm-12 grid-margin stretch-card"
  }, [_c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-brand', {
    staticStyle: {
      "padding": "0.475rem 1rem"
    }
  }, [_c('h3', [_vm._v("Growth Dashboard")])]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button-group', {
    staticClass: "ml-1 text-right",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.previousDash
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.CustomDateList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select",
      "isDisabled": _vm.QFlag
    },
    on: {
      "input": _vm.getCurrentLastDate
    },
    model: {
      value: (_vm.QDFilter),
      callback: function($$v) {
        _vm.QDFilter = $$v
      },
      expression: "QDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    staticClass: "mb-1",
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.DFlag ? true : false
    },
    on: {
      "update": _vm.getData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.branchList,
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.CustomTypeList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getData()
      }
    },
    model: {
      value: (_vm.typeFilter),
      callback: function($$v) {
        _vm.typeFilter = $$v
      },
      expression: "typeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    staticClass: "mb-1",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "mb-1",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAnalysis('Growth_Dashboard_Invoice_Excel', 'Export')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(
    (_vm.dateRange.startDate ||
      _vm.branchfilter ||
      _vm.ProfitLossCardFlag == true ||
      _vm.QDFilter)

  ) ? _c('ProfitLossCard', {
    ref: "profitLossCardComp",
    attrs: {
      "PMC_title": 'PL Growth Dashboard Profit Loss MQY AMT',
      "PMC_QDFilter": _vm.QDFilter,
      "PMC_dateRange": _vm.dateRange,
      "PMC_startDate": _vm.startDate,
      "PMC_endDate": _vm.endDate,
      "PMC_branchfilter": _vm.branchfilter,
      "PMC_DFlag": _vm.DFlag,
      "PMC_QFlag": _vm.QFlag,
      "PMC_ProfitLossCardFlag": _vm.ProfitLossCardFlag,
      "PMC_typeFilter": _vm.typeFilter,
      "PMC_showInternalFilters": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('branch-wise-monthly-growth-component', {
    ref: "branchWiseMonthlyGrowthComp",
    attrs: {
      "BWMC_title": 'Growth Dashboard Branch Wise Monthly Growth MQY AMT',
      "BWMC_QDFilter": _vm.QDFilter,
      "BWMC_dateRange": _vm.dateRange,
      "BWMC_startDate": _vm.startDate,
      "BWMC_endDate": _vm.endDate,
      "BWMC_branchfilter": _vm.branchfilter,
      "BWMC_DFlag": _vm.DFlag,
      "BWMC_QFlag": _vm.QFlag,
      "BWMC_typeFilter": _vm.typeFilter,
      "filters": _vm.growthDashboardFilters,
      "isGraph": false
    }
  }), _vm._v(" "), _c('monthly-growth-component', {
    ref: "monthlyGrowthComp",
    attrs: {
      "MGC_title": 'Growth Dashboard Monthly Growth MQY AMT',
      "MGC_QDFilter": _vm.QDFilter,
      "MGC_dateRange": _vm.dateRange,
      "MGC_startDate": _vm.startDate,
      "MGC_endDate": _vm.endDate,
      "MGC_branchfilter": _vm.branchfilter,
      "MGC_DFlag": _vm.DFlag,
      "MGC_QFlag": _vm.QFlag,
      "MGC_typeFilter": _vm.typeFilter,
      "filters": _vm.growthDashboardFilters,
      "isGraph": false
    }
  }), _vm._v(" "), _c('branch-wise-growth-component', {
    ref: "branchWiseGrowthComp",
    attrs: {
      "BWGC_title": 'Growth Dashboard Branch Wise Growth MQY AMT',
      "BWGC_QDFilter": _vm.QDFilter,
      "BWGC_dateRange": _vm.dateRange,
      "BWGC_startDate": _vm.startDate,
      "BWGC_endDate": _vm.endDate,
      "BWGC_branchfilter": _vm.branchfilter,
      "BWGC_DFlag": _vm.DFlag,
      "BWGC_QFlag": _vm.QFlag,
      "BWGC_typeFilter": _vm.typeFilter,
      "filters": _vm.growthDashboardFilters,
      "isGraph": false
    }
  })], 1)], 1), _vm._v(" "), (_vm.ContexecDataCount.length > 0 || _vm.ExeDataCount.length > 0) ? _c('div', {
    staticClass: "col-md-12 tree",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('allExecution')
      }
    }
  }, [_vm._v("\n                    TUES =\n                    " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContTUES ?
    _vm.ContexecDataCount[0].totalExecutionContTUES :
    0) + "\n                    "), _c('br'), _vm._v("\n                    TCS =\n                    " + _vm._s(_vm.ContexecDataCount[0].totalExecutionCont ?
    _vm.ContexecDataCount[0].totalExecutionCont :
    0) + "\n                    "), _c('br'), _vm._v("\n                    Total Execution =\n                    " + _vm._s(_vm.ExeDataCount[0].totalExecution ?
    _vm.ExeDataCount[0].totalExecution :
    0) + "\n                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('expExecution')
      }
    }
  }, [_vm._v("\n                            TUES =\n                            " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContSeaExpTUES ?
    _vm.ContexecDataCount[0].totalExecutionContSeaExpTUES :
    0) + "\n                            "), _c('br'), _vm._v("\n                            TCS =\n                            " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContExp ?
    _vm.ContexecDataCount[0].totalExecutionContExp :
    0) + "\n                            "), _c('br'), _vm._v("\n                            Export =\n                            " + _vm._s(_vm.ExeDataCount[0].TotExportExe ?
    _vm.ExeDataCount[0].TotExportExe :
    0) + "\n                          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaExpExecution')
      }
    }
  }, [_vm._v("\n                                TUES =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContSeaExpTUES ?
    _vm.ContexecDataCount[0].totalExecutionContSeaExpTUES :
    0) + "\n                                "), _c('br'), _vm._v("\n                                TCS =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContSeaExp ?
    _vm.ContexecDataCount[0].totalExecutionContSeaExp :
    0) + "\n                                "), _c('br'), _vm._v("\n                                Sea Export\n                                " + _vm._s(_vm.ExeDataCount[0].TotSeaExportExe ?
    _vm.ExeDataCount[0].TotSeaExportExe :
    0) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaExpFFExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFSeaExportExeContTUES ?
    _vm.ContexecDataCount[0].TotFFSeaExportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFSeaExportExeCont ?
    _vm.ContexecDataCount[0].TotFFSeaExportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    FF =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotFFSeaExportExe ?
    _vm.ExeDataCount[0].TotFFSeaExportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaExpCCExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCSeaExportExeContTUES ?
    _vm.ContexecDataCount[0].TotCCSeaExportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCSeaExportExeCont ?
    _vm.ContexecDataCount[0].TotCCSeaExportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    CC =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotCCSeaExportExe ?
    _vm.ExeDataCount[0].TotCCSeaExportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaExpTPTExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTSeaExportExeContTUES ?
    _vm.ContexecDataCount[0]
    .TotTPTSeaExportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTSeaExportExeCont ?
    _vm.ContexecDataCount[0].TotTPTSeaExportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TPT =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotTPTSeaExportExe ?
    _vm.ExeDataCount[0].TotTPTSeaExportExe :
    0) + "\n                                  ")])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airExpExecution')
      }
    }
  }, [_vm._v("\n                                TUES =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContAirExpTUES ?
    _vm.ContexecDataCount[0].totalExecutionContAirExpTUES :
    0) + "\n                                "), _c('br'), _vm._v("\n                                TCS =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContAirExp ?
    _vm.ContexecDataCount[0].totalExecutionContAirExp :
    0) + "\n                                "), _c('br'), _vm._v("\n                                Air Export =\n                                " + _vm._s(_vm.ExeDataCount[0].TotAirExportExe ?
    _vm.ExeDataCount[0].TotAirExportExe :
    0) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airExpFFExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFAirExportExeContTUES ?
    _vm.ContexecDataCount[0].TotFFAirExportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFAirExportExeCont ?
    _vm.ContexecDataCount[0].TotFFAirExportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    FF =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotFFAirExportExe ?
    _vm.ExeDataCount[0].TotFFAirExportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airExpCCExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCAirExportExeContTUES ?
    _vm.ContexecDataCount[0].TotCCAirExportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCAirExportExeCont ?
    _vm.ContexecDataCount[0].TotCCAirExportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    CC =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotCCAirExportExe ?
    _vm.ExeDataCount[0].TotCCAirExportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airExpTPTExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTAirExportExeContTUES ?
    _vm.ContexecDataCount[0]
    .TotTPTAirExportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTAirExportExeCont ?
    _vm.ContexecDataCount[0].TotTPTAirExportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TPT =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotTPTAirExportExe ?
    _vm.ExeDataCount[0].TotTPTAirExportExe :
    0) + "\n                                  ")])])])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('impExecution')
      }
    }
  }, [_vm._v("\n                            TUES =\n                            " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContImpTUES ?
    _vm.ContexecDataCount[0].totalExecutionContImpTUES :
    0) + "\n                            "), _c('br'), _vm._v("\n                            TCS =\n                            " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContImp ?
    _vm.ContexecDataCount[0].totalExecutionContImp :
    0) + "\n                            "), _c('br'), _vm._v("\n                            Import =" + _vm._s(_vm.ExeDataCount[0].TotImportExe ?
    _vm.ExeDataCount[0].TotImportExe :
    0) + "\n                          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaImpExecution')
      }
    }
  }, [_vm._v("\n                                TUES =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContSeaImpTUES ?
    _vm.ContexecDataCount[0].totalExecutionContSeaImpTUES :
    0) + "\n                                "), _c('br'), _vm._v("\n                                TCS =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContSeaImp ?
    _vm.ContexecDataCount[0].totalExecutionContSeaImp :
    0) + "\n                                "), _c('br'), _vm._v("\n                                Sea Import =\n                                " + _vm._s(_vm.ExeDataCount[0].TotSeaImportExe ?
    _vm.ExeDataCount[0].TotSeaImportExe :
    0) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaImpFFExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFSeaImportExeContTUES ?
    _vm.ContexecDataCount[0].TotFFSeaImportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFSeaImportExeCont ?
    _vm.ContexecDataCount[0].TotFFSeaImportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    FF =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotFFSeaImportExe ?
    _vm.ExeDataCount[0].TotFFSeaImportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaImpCCExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCSeaImportExeContTUES ?
    _vm.ContexecDataCount[0].TotCCSeaImportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCSeaImportExeCont ?
    _vm.ContexecDataCount[0].TotCCSeaImportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    CC =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotCCSeaImportExe ?
    _vm.ExeDataCount[0].TotCCSeaImportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('seaImpTPTExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTSeaImportExeContTUES ?
    _vm.ContexecDataCount[0]
    .TotTPTSeaImportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTSeaImportExeCont ?
    _vm.ContexecDataCount[0].TotTPTSeaImportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TPT =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotTPTSeaImportExe ?
    _vm.ExeDataCount[0].TotTPTSeaImportExe :
    0) + "\n                                  ")])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airImpExecution')
      }
    }
  }, [_vm._v("\n                                TUES =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContAirImpTUES ?
    _vm.ContexecDataCount[0].totalExecutionContAirImpTUES :
    0) + "\n                                "), _c('br'), _vm._v("\n                                TCS =\n                                " + _vm._s(_vm.ContexecDataCount[0].totalExecutionContAirImp ?
    _vm.ContexecDataCount[0].totalExecutionContAirImp :
    0) + "\n                                "), _c('br'), _vm._v("\n                                Air Import =\n                                " + _vm._s(_vm.ExeDataCount[0].TotAirImportExe ?
    _vm.ExeDataCount[0].TotAirImportExe :
    0) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airImpFFExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFAirImportExeContTUES ?
    _vm.ContexecDataCount[0].TotFFAirImportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotFFAirImportExeCont ?
    _vm.ContexecDataCount[0].TotFFAirImportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    FF =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotFFAirImportExe ?
    _vm.ExeDataCount[0].TotFFAirImportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airImpCCExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCAirImportExeContTUES ?
    _vm.ContexecDataCount[0].TotCCAirImportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotCCAirImportExeCont ?
    _vm.ContexecDataCount[0].TotCCAirImportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    CC =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotCCAirImportExe ?
    _vm.ExeDataCount[0].TotCCAirImportExe :
    0) + "\n                                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('airImpTPTExecution')
      }
    }
  }, [_vm._v("\n                                    TUES =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTAirImportExeContTUES ?
    _vm.ContexecDataCount[0]
    .TotTPTAirImportExeContTUES :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TCS =\n                                    " + _vm._s(_vm.ContexecDataCount[0].TotTPTAirImportExeCont ?
    _vm.ContexecDataCount[0].TotTPTAirImportExeCont :
    0) + "\n                                    "), _c('br'), _vm._v("\n                                    TPT =\n                                    " + _vm._s(_vm.ExeDataCount[0].TotTPTAirImportExe ?
    _vm.ExeDataCount[0].TotTPTAirImportExe :
    0) + "\n                                  ")])])])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.seriesRevenu[0].data.length > 0) ? _c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTALRevenues Chart")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.seriesRevenu[0].data.length > 0) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "line",
      "height": "350",
      "width": "1350",
      "options": _vm.chartOptionsRevenu,
      "series": _vm.seriesRevenu
    }
  }) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.DateRangeContexecWithRevenuTargetDataCount.length > 0) ? _c('div', {
    staticClass: "col-md-12 mt-2 mb-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm gutr"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("EXP TPT")]), _vm._v(" "), _c('th', [_vm._v("EXP CC")]), _vm._v(" "), _c('th', [_vm._v("EXP FF")]), _vm._v(" "), _c('th', [_vm._v("IMP TPT")]), _vm._v(" "), _c('th', [_vm._v("IMP CC")]), _vm._v(" "), _c('th', [_vm._v("IMP FF")]), _vm._v(" "), _c('th', [_vm._v("Revenue")])]), _vm._v(" "), _vm._l((_vm.DateRangeContexecWithRevenuTargetDataCount), function(DR_Rev_item, DR_Rev_index) {
    return _c('tr', {
      key: DR_Rev_index
    }, [_c('td', [_vm._v("\n                      " + _vm._s(DR_Rev_item.month) + "\n                      ")]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (DR_Rev_item.TotTPTSeaExportExeContTUES ?
        DR_Rev_item.TotTPTSeaExportExeContTUES :
        0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("Target TUES :")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_TotTPTSeaExportExeContTUES",
        "id": "target_TotTPTSeaExportExeContTUES"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_TotTPTSeaExportExeContTUES),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_TotTPTSeaExportExeContTUES", $$v)
        },
        expression: "DR_Rev_item.target_TotTPTSeaExportExeContTUES"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_TotTPTSeaExportExeContTUES ?
      parseFloat(
        (DR_Rev_item.TotTPTSeaExportExeContTUES /
          DR_Rev_item.target_TotTPTSeaExportExeContTUES) *
        100
      ).toFixed(2) :
      "0")) + "%")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (DR_Rev_item.TotCCSeaExportExeContTUES ?
        DR_Rev_item.TotCCSeaExportExeContTUES :
        0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("\n                          Target\n                          "), _vm._v("\n                          :\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_TotCCSeaExportExeContTUES",
        "id": "target_TotCCSeaExportExeContTUES"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_TotCCSeaExportExeContTUES),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_TotCCSeaExportExeContTUES", $$v)
        },
        expression: "DR_Rev_item.target_TotCCSeaExportExeContTUES"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_TotCCSeaExportExeContTUES ?
      parseFloat(
        (DR_Rev_item.TotCCSeaExportExeContTUES /
          DR_Rev_item.target_TotCCSeaExportExeContTUES) *
        100
      ).toFixed(2) :
      "0")) + "%")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (DR_Rev_item.TotFFSeaExportExeContTUES ?
        DR_Rev_item.TotFFSeaExportExeContTUES :
        0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("Target TUES :")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_TotFFSeaExportExeContTUES",
        "id": "target_TotFFSeaExportExeContTUES"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_TotFFSeaExportExeContTUES),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_TotFFSeaExportExeContTUES", $$v)
        },
        expression: "DR_Rev_item.target_TotFFSeaExportExeContTUES"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_TotFFSeaExportExeContTUES ?
      parseFloat(
        (DR_Rev_item.TotFFSeaExportExeContTUES /
          DR_Rev_item.target_TotFFSeaExportExeContTUES) *
        100
      ).toFixed(2) :
      "0")) + "%")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (DR_Rev_item.TotTPTSeaImportExeContTUES ?
        DR_Rev_item.TotTPTSeaImportExeContTUES :
        0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("Target TUES :")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_TotTPTSeaImportExeContTUES",
        "id": "target_TotTPTSeaImportExeContTUES"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_TotTPTSeaImportExeContTUES),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_TotTPTSeaImportExeContTUES", $$v)
        },
        expression: "DR_Rev_item.target_TotTPTSeaImportExeContTUES"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_TotTPTSeaImportExeContTUES ?
      parseFloat(
        (DR_Rev_item.TotTPTSeaImportExeContTUES /
          DR_Rev_item.target_TotTPTSeaImportExeContTUES) *
        100
      ).toFixed(2) :
      "0")) + "%")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (DR_Rev_item.TotCCSeaImportExeContTUES ?
        DR_Rev_item.TotCCSeaImportExeContTUES :
        0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("Target TUES :")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_TotCCSeaImportExeContTUES",
        "id": "target_TotCCSeaImportExeContTUES"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_TotCCSeaImportExeContTUES),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_TotCCSeaImportExeContTUES", $$v)
        },
        expression: "DR_Rev_item.target_TotCCSeaImportExeContTUES"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_TotCCSeaImportExeContTUES ?
      parseFloat(
        (DR_Rev_item.TotCCSeaImportExeContTUES /
          DR_Rev_item.target_TotCCSeaImportExeContTUES) *
        100
      ).toFixed(2) :
      "0")) + "%")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (DR_Rev_item.TotFFSeaImportExeContTUES ?
        DR_Rev_item.TotFFSeaImportExeContTUES :
        0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("Target TUES :")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_TotFFSeaImportExeContTUES",
        "id": "target_TotFFSeaImportExeContTUES"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_TotFFSeaImportExeContTUES),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_TotFFSeaImportExeContTUES", $$v)
        },
        expression: "DR_Rev_item.target_TotFFSeaImportExeContTUES"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_TotFFSeaImportExeContTUES ?
      parseFloat(
        (DR_Rev_item.TotFFSeaImportExeContTUES /
          DR_Rev_item.target_TotFFSeaImportExeContTUES) *
        100
      ).toFixed(2) :
      "0")) + "%")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("\n                        " + _vm._s(DR_Rev_item.caltotalTallyAddedRevenueSum ?
      "₹" +
      _vm.changeNumberFormat(
        parseFloat(DR_Rev_item.caltotalTallyAddedRevenueSum)
      ) :
      0) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('label', {
      staticClass: "col-md-12"
    }, [_vm._v("Target Revenue :")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "5px 5px",
        "height": "24px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": _vm.growthPermission == 'No' &&
          _vm.$sessionsStorage.get('designation') != 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
          true :
          false,
        "name": "target_caltotalTallyAddedRevenueSum",
        "id": "target_caltotalTallyAddedRevenueSum"
      },
      on: {
        "keyup": _vm.TotalDetails
      },
      model: {
        value: (DR_Rev_item.target_caltotalTallyAddedRevenueSum),
        callback: function($$v) {
          _vm.$set(DR_Rev_item, "target_caltotalTallyAddedRevenueSum", $$v)
        },
        expression: "DR_Rev_item.target_caltotalTallyAddedRevenueSum"
      }
    })], 1)]), _vm._v(" "), _c('b', {
      staticStyle: {
        "color": "purple",
        "font-weight": "bold"
      }
    }, [_vm._v("Achievement =\n                        " + _vm._s((_vm.Achievement = DR_Rev_item.target_caltotalTallyAddedRevenueSum ?
      parseFloat(
        (DR_Rev_item.caltotal_GstRevenueSumVal /
          DR_Rev_item.target_caltotalTallyAddedRevenueSum) *
        100
      ).toFixed(2) :
      "0")) + "%")])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total TUES = " + _vm._s(_vm.Total_TotTPTSeaExportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total Target TUES =\n                        " + _vm._s(_vm.Total_target_TotTPTSeaExportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_TotTPTSeaExportExeContTUES ?
    parseFloat(
      (_vm.Total_TotTPTSeaExportExeContTUES /
        _vm.Total_target_TotTPTSeaExportExeContTUES) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total TUES = " + _vm._s(_vm.Total_TotCCSeaExportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total Target TUES = " + _vm._s(_vm.Total_target_TotCCSeaExportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_TotCCSeaExportExeContTUES ?
    parseFloat(
      (_vm.Total_TotCCSeaExportExeContTUES /
        _vm.Total_target_TotCCSeaExportExeContTUES) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total TUES = " + _vm._s(_vm.Total_TotFFSeaExportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total Target TUES = " + _vm._s(_vm.Total_target_TotFFSeaExportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_TotFFSeaExportExeContTUES ?
    parseFloat(
      (_vm.Total_TotFFSeaExportExeContTUES /
        _vm.Total_target_TotFFSeaExportExeContTUES) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total TUES = " + _vm._s(_vm.Total_TotTPTSeaImportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total Target TUES =\n                        " + _vm._s(_vm.Total_target_TotTPTSeaImportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_TotTPTSeaImportExeContTUES ?
    parseFloat(
      (_vm.Total_TotTPTSeaImportExeContTUES /
        _vm.Total_target_TotTPTSeaImportExeContTUES) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total TUES = " + _vm._s(_vm.Total_TotCCSeaImportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total Target TUES = " + _vm._s(_vm.Total_target_TotCCSeaImportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_TotCCSeaImportExeContTUES ?
    parseFloat(
      (_vm.Total_TotCCSeaImportExeContTUES /
        _vm.Total_target_TotCCSeaImportExeContTUES) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total TUES = " + _vm._s(_vm.Total_TotFFSeaImportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total Target TUES = " + _vm._s(_vm.Total_target_TotFFSeaImportExeContTUES) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_TotFFSeaImportExeContTUES ?
    parseFloat(
      (_vm.Total_TotFFSeaImportExeContTUES /
        _vm.Total_target_TotFFSeaImportExeContTUES) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])]), _vm._v(" "), _c('td', [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "12px"
    }
  }, [_vm._v("\n                        Total Revenue =\n                        " + _vm._s(_vm.changeNumberFormat(_vm.Total_caltotalTallyAddedRevenueSum)) + "\n                        "), _c('br'), _vm._v("\n                        Total Target Revenue =\n                        " + _vm._s(_vm.changeNumberFormat(_vm.Total_target_caltotalTallyAddedRevenueSum)) + "\n                        "), _c('br'), _vm._v("\n                        Total =\n                        " + _vm._s((_vm.Achievement = _vm.Total_target_caltotalTallyAddedRevenueSum ?
    parseFloat(
      (_vm.Total_caltotalTallyAddedRevenueSum /
        _vm.Total_target_caltotalTallyAddedRevenueSum) *
      100
    ).toFixed(2) :
    "0")) + "%\n                      ")])])]), _vm._v(" "), (_vm.DateRangeContexecWithRevenuTargetDataCount.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('center', [(
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.branchfilter != ''
  ) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "SaveTargetValues"
    },
    on: {
      "click": _vm.SaveTargetValues
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.DateRangeContexecWithRevenuTargetDataCount.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "purple"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Data Not Found")])])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.DateRangeContexecDataCount.length > 0) ? _c('div', {
    staticClass: "col-md-12 mt-2 mb-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm gutr"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Service Wise Volume Analysis")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("SEA")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.branchfilter ? _vm.branchfilterName : "All"))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Date Range")]), _vm._v(" "), _c('th', [_vm._v("\n                      From :\n                      " + _vm._s(_vm._f("moment")(_vm.dateRange.startDate ?
    _vm.dateRange.startDate :
    "04-01-2022")) + "\n                      - To :\n                      " + _vm._s(_vm._f("moment")(_vm.dateRange.endDate ? _vm.dateRange.endDate : new Date())) + "\n                    ")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("EXP TPT")]), _vm._v(" "), _c('th', [_vm._v("EXP CC")]), _vm._v(" "), _c('th', [_vm._v("EXP FF")]), _vm._v(" "), _c('th', [_vm._v("IMP TPT")]), _vm._v(" "), _c('th', [_vm._v("IMP CC")]), _vm._v(" "), _c('th', [_vm._v("IMP FF")])]), _vm._v(" "), _vm._l((_vm.DateRangeContexecDataCount), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.fromDate + " to " + item.toDate))]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item.TotTPTSeaExportExeContTUES ?
        item.TotTPTSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item.TotTPTSeaExportExeCont ?
        item.TotTPTSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item.TotTPTSeaExportExe ? item.TotTPTSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item.TotCCSeaExportExeContTUES ?
        item.TotCCSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item.TotCCSeaExportExeCont ? item.TotCCSeaExportExeCont : 0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item.TotCCSeaExportExe ? item.TotCCSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item.TotFFSeaExportExeContTUES ?
        item.TotFFSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item.TotFFSeaExportExeCont ? item.TotFFSeaExportExeCont : 0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item.TotFFSeaExportExe ? item.TotFFSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item.TotTPTSeaImportExeContTUES ?
        item.TotTPTSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item.TotTPTSeaImportExeCont ?
        item.TotTPTSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item.TotTPTSeaImportExe ? item.TotTPTSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item.TotCCSeaImportExeContTUES ?
        item.TotCCSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item.TotCCSeaImportExeCont ? item.TotCCSeaImportExeCont : 0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item.TotCCSeaImportExe ? item.TotCCSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item.TotFFSeaImportExeContTUES ?
        item.TotFFSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item.TotFFSeaImportExeCont ? item.TotFFSeaImportExeCont : 0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item.TotFFSeaImportExe ? item.TotFFSeaImportExe : 0)) + "\n                      ")])])])
  }), _vm._v(" "), (_vm.DateRangeContexecDataCount.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "purple"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Data Not Found")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("EXP TPT")]), _vm._v(" "), _c('th', [_vm._v("EXP CC")]), _vm._v(" "), _c('th', [_vm._v("EXP FF")]), _vm._v(" "), _c('th', [_vm._v("EXP CT")]), _vm._v(" "), _c('th', [_vm._v("EXP FT")]), _vm._v(" "), _c('th', [_vm._v("EXP CF")]), _vm._v(" "), _c('th', [_vm._v("EXP INT")]), _vm._v(" "), _c('th', [_vm._v("IMP TPT")]), _vm._v(" "), _c('th', [_vm._v("IMP CC")]), _vm._v(" "), _c('th', [_vm._v("IMP FF")]), _vm._v(" "), _c('th', [_vm._v("IMP CT")]), _vm._v(" "), _c('th', [_vm._v("IMP FT")]), _vm._v(" "), _c('th', [_vm._v("IMP CF")]), _vm._v(" "), _c('th', [_vm._v("IMP INT")])]), _vm._v(" "), _vm._l((_vm.DateRangeContexecDataCount), function(item_1, index_1) {
    return _c('tr', {
      key: index_1
    }, [_c('td', [_vm._v(_vm._s(item_1.fromDate + " to " + item_1.toDate))]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotTPTSeaExportExeContTUES ?
        item_1.TotTPTSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotTPTSeaExportExeCont ?
        item_1.TotTPTSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotTPTSeaExportExe ? item_1.TotTPTSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotCCSeaExportExeContTUES ?
        item_1.TotCCSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotCCSeaExportExeCont ?
        item_1.TotCCSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotCCSeaExportExe ? item_1.TotCCSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotFFSeaExportExeContTUES ?
        item_1.TotFFSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotFFSeaExportExeCont ?
        item_1.TotFFSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotFFSeaExportExe ? item_1.TotFFSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotCTSeaExportExeContTUES ?
        item_1.TotCTSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotCTSeaExportExeCont ?
        item_1.TotCTSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotCTSeaExportExe ? item_1.TotCTSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotFTSeaExportExeContTUES ?
        item_1.TotFTSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotFTSeaExportExeCont ?
        item_1.TotFTSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotFTSeaExportExe ? item_1.TotFTSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotCFSeaExportExeContTUES ?
        item_1.TotCFSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotCFSeaExportExeCont ?
        item_1.TotCFSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotCFSeaExportExe ? item_1.TotCFSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotINTSeaExportExeContTUES ?
        item_1.TotINTSeaExportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotINTSeaExportExeCont ?
        item_1.TotINTSeaExportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotINTSeaExportExe ? item_1.TotINTSeaExportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotTPTSeaImportExeContTUES ?
        item_1.TotTPTSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotTPTSeaImportExeCont ?
        item_1.TotTPTSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotTPTSeaImportExe ? item_1.TotTPTSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotCCSeaImportExeContTUES ?
        item_1.TotCCSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotCCSeaImportExeCont ?
        item_1.TotCCSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotCCSeaImportExe ? item_1.TotCCSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotFFSeaImportExeContTUES ?
        item_1.TotFFSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotFFSeaImportExeCont ?
        item_1.TotFFSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotFFSeaImportExe ? item_1.TotFFSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotCTSeaImportExeContTUES ?
        item_1.TotCTSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotCTSeaImportExeCont ?
        item_1.TotCTSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotCTSeaImportExe ? item_1.TotCTSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotFTSeaImportExeContTUES ?
        item_1.TotFTSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotFTSeaImportExeCont ?
        item_1.TotFTSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotFTSeaImportExe ? item_1.TotFTSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotCFSeaImportExeContTUES ?
        item_1.TotCFSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotCFSeaImportExeCont ?
        item_1.TotCFSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotCFSeaImportExe ? item_1.TotCFSeaImportExe : 0)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('b', [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                          " + _vm._s("TEUS = " +
      (item_1.TotINTSeaImportExeContTUES ?
        item_1.TotINTSeaImportExeContTUES :
        0)) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s("Containers = " +
      (item_1.TotINTSeaImportExeCont ?
        item_1.TotINTSeaImportExeCont :
        0)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s("Execution = " +
      (item_1.TotINTSeaImportExe ? item_1.TotINTSeaImportExe : 0)) + "\n                      ")])])])
  }), _vm._v(" "), (_vm.DateRangeContexecDataCount.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "purple"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Data Not Found")])])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (
    _vm.seriesExp[0].data.length > 0 ||
    _vm.seriesExp[1].data.length > 0 ||
    _vm.seriesExp[2].data.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL TEUS EXP MODULES")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(
    _vm.seriesExp[0].data.length > 0 ||
    _vm.seriesExp[1].data.length > 0 ||
    _vm.seriesExp[2].data.length > 0
  ) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "line",
      "height": "350",
      "width": "1350",
      "options": _vm.chartOptionsExp,
      "series": _vm.seriesExp
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.seriesImp[0].data.length > 0 ||
    _vm.seriesImp[1].data.length > 0 ||
    _vm.seriesImp[2].data.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL TEUS IMP MODULES")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(
    _vm.seriesImp[0].data.length > 0 ||
    _vm.seriesImp[1].data.length > 0 ||
    _vm.seriesImp[2].data.length > 0
  ) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "line",
      "height": "350",
      "width": "1350",
      "options": _vm.chartOptionsImp,
      "series": _vm.seriesImp
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348b9db3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/analysisDashboard.vue
// module id = 2514
// module chunks = 0